"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpLocaleSwitcher = void 0;
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const locale_switcher_html_1 = __importDefault(require("./locale-switcher.html"));
let ItpLocaleSwitcher = class ItpLocaleSwitcher extends vue_property_decorator_1.Vue {
    currentLocale;
    data() {
        return {
            currentLocale: _.find(this.$app.i18n.getLocales(), {
                code: this.$app.i18n.locale
            })
        };
    }
    get localesInDropdown() {
        return _.filter(this.$app.i18n.getLocales(), p => p.code !== this.currentLocale.code);
    }
    setLocale(locale) {
        this.$app.i18n.setLocale(locale.code);
    }
};
exports.ItpLocaleSwitcher = ItpLocaleSwitcher;
exports.ItpLocaleSwitcher = ItpLocaleSwitcher = __decorate([
    (0, vue_property_decorator_1.Component)({ template: locale_switcher_html_1.default })
], ItpLocaleSwitcher);
//# sourceMappingURL=locale-switcher.js.map